import freight from './freight';
import provider from './provider';

export default [
    freight,
    provider,
];
